import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { artifactUrl } from "./artifact-utils";

/**
 * Paketi indirir. Dosya Public altından statik servis edildiği için bağlantı doğrudan tarayıcıya
 * verilir: 200 MB'lık bir JDK paketi uygulamanın belleğinden geçmez, indirme tarayıcının işi olur.
 */
export default function ArtifactDownloadButton({ artifact, size = 'small', type = 'default' }) {
    const { t } = useTranslation();
    const url = artifactUrl(artifact);

    if (!url) {
        return null;
    }

    return (
        <Tooltip title={artifact.originalName || undefined}>
            <Button
                size={size}
                type={type}
                icon={<DownloadOutlined />}
                href={url}
                download
                target="_blank"
                rel="noreferrer"
            >
                {t('Download')}
            </Button>
        </Tooltip>
    );
}
